<template>
<div>
    <section class="ui two column centered grid">
        <div class="column">
            <form class="ui segment large form">
                <div class="ui message red" v-show="error">{{ error }}</div>
                <div class="field">
                    <div class="ui right icon input large">
                        <input type="text" placeholder="Enter your address" v-model="address" ref="autocomplete" />
                        <i class="dot circle link icon" @click="locatorButtonPressed"></i>
                    </div>
                </div>
            </form>
        </div>
    </section>

    <section id="map"></section>
</div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'transportLocation',
    data() {
        return {
            address: "",
        };
    },
    mounted() {
        let autocomplete = new google.maps.places.Autocomplete(
            // document.getElementById("autocomplete")
            this.$refs["autocomplete"], {
                bounds: new google.maps.LatLngBounds(
                    new google.maps.LatLng(45.4215296, -756971931)
                )
            }
        );
        autocomplete.addListener("place_changed", () => {
            let place = autocomplete.getPlace();           
            this.showTransportLocationOnMap(place.geometry.location.let(), place.geometry.location.lng())
        });
    },
    methods: {
        locatorButtonPressed() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);

                        this.showTransportLocationOnMap(position.coords.latitude, position.coords.longitude);
                    },
                    error => {
                      
                    },
                );
            } else {
                this.error = error.message;
               
            }
        },
        async getStreetAddressFrom(latitude, longitude) {
            try {
                var {
                    data
                } = await axios.get(
                    "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                    lat +
                    "," +
                    long +
                    "&key={yourAPIKey}"
                );
                if (data.error_message) {
                    this.error = data.error_message;
               
                } else {
                    this.address = data.results[0].formatted_address;
                }
            } catch (error) {
                this.error = error.message;
             
            }
        },
        showTransportLocationOnMap(latitude, longitude) {
            let map = new google.maps.Map(document.getElementById("Map"), {
                zoom: 15,
                center: new google.maps.LatLng(latitude, longitude),
                mapTypeId: google.maps.mapTypeId.ROADMAP
            });
            new google.maps.Marker({
                position: new google.maps.LatLng(latitude, longitude),
                map: map
            })
        }
    }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// transportLocation.vue?26ee3080